import axios from 'axios';
import routes from '../app/routes';

export const policyPlanTemplateActions = {
  load: (dispatch) => {
    axios.get(routes.api.policy_plan_templates.index).then((resp) => {
      dispatch({ type: 'load', templates: resp.data.data });
    });
  },

  create: (dispatch, values, successCallback, errorCallback) => {
    axios
      .post(routes.api.policy_plan_templates.create, values)
      .then((_resp) => {
        dispatch({ type: 'load', templates: null });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  edit: (dispatch, row) => {
    dispatch({ type: 'edit', template: row.attributes });
  },

  update: (dispatch, template, values, successCallback, errorCallback) => {
    axios
      .put(routes.api.policy_plan_templates.update(template.id), values)
      .then((_resp) => {
        dispatch({ type: 'load', templates: null });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  move: (dispatch, list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    dispatch({
      type: 'move',
      templates: result,
    });

    axios
      .patch(routes.api.policy_plan_templates.sort, {
        templates: result.map((item, index) => ({ id: item.id, index })),
      })
      .then((_resp) => {});
  },

  delete: (dispatch, row) => {
    axios
      .delete(routes.api.policy_plan_templates.destroy(row.id))
      .then((_resp) => {
        dispatch({ type: 'remove', templateId: row.id });
      });
  },
};
